import { render, staticRenderFns } from "./PlatingTasks.vue?vue&type=template&id=4258fc6c&scoped=true&"
import script from "./PlatingTasks.vue?vue&type=script&lang=js&"
export * from "./PlatingTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4258fc6c",
  null
  
)

export default component.exports